angular.module('dpw.components')
    .value('getFeedBurnerUri', function() {
        !RCDPW.feedBurnerUri && RCDPW.console.warn(
            'RCDPW.feedBurnerUri is undefined.',
            'This is an issue when site is running on stage/production.'
        );
        return RCDPW.feedBurnerUri || 'RingcentralConnectDeveloperPlatformLab';
    })
    .directive('dpwBlogSubscribe', [function () {
        return {
            restrict: 'A',
            controller: ['blogInfo', 'getFeedBurnerUri', function (blogInfo, getFeedBurnerUri) {
                this.blogInfo = blogInfo;
                this.feedBurnerUri = getFeedBurnerUri();
            }],
            controllerAs: 'SubscribeCtrl',
            templateUrl: 'dpw-blog-subscribe.html'
        };
    }]);
